import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";
import AppConstatnts from "../common/AppConstants";

export const BallotDashboardService = {
  getCombineYears,
  getBallotVotePlayersList,
  insertBallotVotePlayersList,
  getAdminViewBallotVoteDetails,
  getTeamWiseAdminViewBallotVoteDetails,
  getBallotVotedTeamDetailsForPlayer,
  getBallotVotedPlayerDetailsByTeam,
  getTeamBallotDashboardFlagForTeamUser,
  submitBallotVoteConfirmationEmailToTeamUser,
  getActiveBallotVoteEventId,
  getTeamPlayerVotedData,
  verifyTeamVotingList,
};
async function getCombineYears() {
  const response = await APIHelper.get(
    APIURLConstants.GET_COMBINE_YEARS,
    authHeader()
  );
  return response;
}

async function getBallotVotePlayersList(teamID, eventId) {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_BALLOT_VOTES_PLAYERS_LIST}/${teamID}/${eventId}`,
    authHeader()
  );
  return response;
}

async function insertBallotVotePlayersList(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_BALLOT_VOTES_PLAYERS_LIST}`,
    formObj,
    authHeader()
  );
  return response;
}

async function getAdminViewBallotVoteDetails(eventId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_ADMIN_VIEW_BALLOT_VOTE_DETAILS(eventId),
    authHeader()
  );
  return response;
}

async function getTeamWiseAdminViewBallotVoteDetails(eventId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_TEAM_WISE_ADMIN_VIEW_BALLOT_VOTE_DETAILS(eventId),
    authHeader()
  );
  return response;
}

async function getBallotVotedTeamDetailsForPlayer(playerID, EventId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_BALLOT_VOTED_TEAM_DETAILS_FOR_PLAYER(playerID, EventId),
    authHeader()
  );
  return response;
}
async function getBallotVotedPlayerDetailsByTeam(teamID, EventId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_BALLOT_VOTED_Players_DETAILS_By_Team(teamID, EventId),
    authHeader()
  );
  return response;
}

async function getTeamBallotDashboardFlagForTeamUser() {
  const response = await APIHelper.get(
    APIURLConstants.GET_TEAM_BALLOT_DASHBOARD_FLAG_FOR_TEAM_USER,
    authHeader()
  );
  return response.data;
}

async function submitBallotVoteConfirmationEmailToTeamUser(eventId, teamId) {
  const response = await APIHelper.get(
    APIURLConstants.SUBMIT_BALLOT_VOTE_CONFIRMATION_EMAIL_TO_TEAM_USER(
      eventId,
      teamId
    ),
    authHeader()
  );
  return response;
}

async function getActiveBallotVoteEventId() {
  const response = await APIHelper.get(
    APIURLConstants.GET_ACTIVE_BALLOTVOTE_EVENT_ID,
    authHeader()
  );
  return response.data;
}

async function getTeamPlayerVotedData(eventId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_TEAM_PLAYER_VOTED_DATA(eventId),
    authHeader()
  );
  return response;
}

async function verifyTeamVotingList(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.VERIFY_VOTTING_LIST}`,
    formObj,
    authHeader()
  );
  return response;
}
